
import BackgroundCategoryAddRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundCategoryService/BackgroundCategoryAddRequest";
import BackgroundCategoryTranslationsRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundCategoryService/BackgroundCategoryTranslationsRequest";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class CreateBackgroundCategoryPage extends Vue {
  isLoading = false;
  request = new BackgroundCategoryAddRequest({
    Id: null,
    Translations: []
  });

  get title(): string {
    return this.id ? "Редактирование категории изображений" : "Добавление категории изображений";
  }

  get id(): number {
    return this.$route.params.id ? Number(this.$route.params.id) : 0;
  }

  async created() {
    const langs = await this.$cacheProvider.getLanguagesAsync();
    this.request.Translations = (langs || []).map((langCode: string) =>
      new BackgroundCategoryTranslationsRequest({
        LangCode: langCode,
        Name: ""
      })
    );
    if (this.id) {
      await this.fetchData();
    }
  }

  async fetchData() {
    this.isLoading = true;
    try {
      const res = await this.$api.BackgroundCategoryService.getDetailAsync(this.id);
      this.request.Id = res.Id;
      (res.Translations || []).forEach((serverTranslation) => {
        let translation = this.request.Translations.find(
          (item) => item.LangCode === serverTranslation.LangCode
        );
        if (!translation) {
          translation = new BackgroundCategoryTranslationsRequest({
            Id: serverTranslation.Id,
            LangCode: serverTranslation.LangCode,
            Name: ""
          });
          this.request.Translations.push(translation);
        }
        translation.Id = serverTranslation.Id;
        translation.Name = serverTranslation.Name;
      });
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  async save() {
    const translations = (this.request.Translations || [])
      .filter((item) => Boolean((item.Name || "").trim()))
      .map((item) => new BackgroundCategoryTranslationsRequest({
        Id: item.Id,
        LangCode: item.LangCode,
        Name: item.Name.trim()
      }));

    if (!translations.length) {
      this.$notification.error("Заполните хотя бы один перевод");
      return;
    }

    const valid = (this.$refs.validator as any).isValid();
    if (!valid) {
      return;
    }

    this.isLoading = true;
    try {
      const result = await this.$api.BackgroundCategoryService.addAsync(
        new BackgroundCategoryAddRequest({
          Id: this.request.Id,
          Translations: translations
        })
      );
      if (result) {
        this.$notification.success(
          this.id ? "Категория успешно обновлена" : "Категория успешно добавлена"
        );
        this.$router.back();
      }
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoading = false;
    }
  }
}
